import React, { useState } from "react";
import ToggleControl from "../toggleControl/toggleControl";
import type { CheckboxModel } from "../../type/toggleControl";
import { BaseModal } from "../modalCommon/modalBase";
import { ModalBody } from "../modalCommon/modalBody";
import { ModalFooter } from "../modalCommon/modalFooter";
import { ModalHeader } from "../modalCommon/modalHeader";
import "./checkbox.scss";
import { useI18n } from "../../utils/translate/i18n/useI18n";

const Checkbox: React.FC<CheckboxModel> = ({
  label,
  description,
  checked,
  onChange,
  saving = false,
  disabled = false,
  variant = "default",
  className = "",
  icon,
  infoTitle = "Informacja",
  infoText
}) => {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const variantClass = variant === "compact" ? "setting-toggle-item-compact" : "setting-toggle-item-default";
  const { t } = useI18n();

  return (
    <div className={`setting-toggle-item ${variantClass} ${className}`.trim()}>

      {icon && (
        <div className="setting-toggle-item-icon-left">
          <i className={`bi ${icon}`} />
        </div>
      )}

      <div className="setting-toggle-item-info">
        <div className="setting-toggle-item-label">{label}</div>
        <div className="setting-toggle-item-description">{description}</div>
      </div>

      {infoText && (
        <button
          type="button"
          className="setting-toggle-item-icon-wrapper setting-toggle-item-icon-button"
          onClick={() => setIsInfoModalOpen(true)}
          aria-label={infoTitle}
        >
          <i className="bi bi-info-circle setting-toggle-item-icon" />
        </button>
      )}

      <ToggleControl
        checked={checked}
        onChange={onChange}
        label={label}
        saving={saving}
        disabled={disabled}
      />

      {infoText && (
        <BaseModal open={isInfoModalOpen} onClose={() => setIsInfoModalOpen(false)} size="md">
          <ModalHeader title={infoTitle} onClose={() => setIsInfoModalOpen(false)} />
          <ModalBody>
            <p className="mb-0">{infoText}</p>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-primary w-100" onClick={() => setIsInfoModalOpen(false)}>
              {t("Zamknij")}
            </button>
          </ModalFooter>
        </BaseModal>
      )}
    </div>
  );
};

export default Checkbox;